var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-scroll',{ref:"scroll",staticClass:"box",attrs:{"height":_vm.height}},_vm._l((_vm.list),function(info,index){return _c('message-box-item',{key:index,class:{mt10:index>0},attrs:{"info":info,"blank":_vm.blank}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }